import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export function useContactSetVisibilityMutation({
	onSuccess,
	onError,
}: {
	onSuccess?: (data: Api.ISystemJob) => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
} = {}) {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: async (request: Api.IContactsSetVisibilityRequest) => {
			return new Promise<Api.ISystemJob>((resolve, reject) => {
				userSession.webServiceHelper
					.callAsync<Api.ISystemJob>(
						Api.ImpersonationBroker.composeApiUrl({
							urlPath: 'contact/visibility',
						}),
						'POST',
						request
					)
					.then(resolve)
					.catch((error: Api.IOperationResultNoValue) => reject(error));
			});
		},
		onSuccess,
		onError,
	});
}
